"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherSettingsMenuSelector = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ShareSettingsOptionSection_1 = require("Common/ShareSettings/ShareSettingsOptionSection");
var GetSubtextForSettings_1 = require("./GetSubtextForSettings");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
exports.OtherSettingsMenuSelector = (0, mobx_react_1.observer)(function (props) {
    return (react_1.default.createElement(ShareSettingsOptionSection_1.ShareSettingsOptionSection, { icon: react_1.default.createElement(icons_1.Settings, null), settingTitle: "Other settings", settingStatus: getSubtext(props), onClick: props.onClick, disabled: props.disabled }));
});
var Setting;
(function (Setting) {
    Setting[Setting["IpFiltering"] = 0] = "IpFiltering";
    Setting[Setting["Indexing"] = 1] = "Indexing";
    Setting[Setting["SocialBadge"] = 2] = "SocialBadge";
    Setting[Setting["ViewLimit"] = 3] = "ViewLimit";
    Setting[Setting["SpringboardEngagementMenu"] = 4] = "SpringboardEngagementMenu";
    Setting[Setting["ContactPageOwner"] = 5] = "ContactPageOwner";
})(Setting || (Setting = {}));
function getSubtext(props) {
    var enabledSettings = getEnabledSettings(props);
    return (0, GetSubtextForSettings_1.getSubtextForSettings)(enabledSettings, textForSetting, "None set");
}
function getEnabledSettings(_a) {
    var ipFilterStore = _a.ipFilterStore, allowIndexing = _a.allowIndexing, enableSocialBadge = _a.enableSocialBadge, viewLimit = _a.viewLimit, usingFeature = _a.usingFeature, projectSettings = _a.projectSettings;
    var enabledSettings = [];
    if (ipFilterStore.enabled) {
        enabledSettings.push(Setting.IpFiltering);
    }
    if (viewLimit.enabled) {
        enabledSettings.push(Setting.ViewLimit);
    }
    if (allowIndexing) {
        enabledSettings.push(Setting.Indexing);
    }
    if (enableSocialBadge) {
        enabledSettings.push(Setting.SocialBadge);
    }
    var usingSpringboard = usingFeature(FeatureFlag_1.default.ConsumerVirality) && !usingFeature(FeatureFlag_1.default.OptOutSpringboardEngagementMenu);
    var usingRefreshedIdentity = !usingFeature(FeatureFlag_1.default.Domain) || usingFeature(FeatureFlag_1.default.RefreshedIdentityProtected);
    var usingRefreshedNavigation = usingFeature(FeatureFlag_1.default.RefreshedNavigationMenu);
    var showSpringboardSettings = usingSpringboard && usingRefreshedIdentity && !usingRefreshedNavigation;
    if (showSpringboardSettings) {
        if (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.springboard.engagementMenuEnabled) {
            enabledSettings.push(Setting.SpringboardEngagementMenu);
        }
        if (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.springboard.contactPageOwnerEnabled) {
            enabledSettings.push(Setting.ContactPageOwner);
        }
    }
    return enabledSettings;
}
function textForSetting(setting, useAbbreviated) {
    switch (setting) {
        case Setting.IpFiltering:
            return "IP filtering";
        case Setting.ViewLimit:
            return useAbbreviated ? "Restrict views" : "Restrict number of views";
        case Setting.Indexing:
            return useAbbreviated ? "Searchable" : "Findable on search engines";
        case Setting.SocialBadge:
            return useAbbreviated ? "Social share" : "Social share buttons";
        case Setting.SpringboardEngagementMenu:
            return "Springboard menu";
        case Setting.ContactPageOwner:
            return useAbbreviated ? "Contact page owner" : "Page owner contact button";
    }
}
